<res-base-modal [modalTitle]="'Reindex Data Set'" [modalClass]="modalClass" [modalAutomationId]="modalAutomationId"
    [primaryButtonLabel]="'Reindex'" (primaryButtonActionEmt)="reindex()"
    (closeButtonActionEmt)="hideReindexDataSetModal()" [isPrimaryBtnEnabled]="!isBusy && okEnabled()"
    [titleText]="okEnabled() ? '' : 'Please select desired index level'" [secondaryButtonLabel]="'Cancel'"
    [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage" [modalHelpIndex]="modalHelpIndex">

    <div class="content-box">
        <div class="inline-display box-margin">Index Level:</div>
        <div class="inline-display">
            <button [disabled]="disableOption(RepresentationSet.SYSTEM_METADATA_INDEX)"
                [attr.data-automation-id]="modalAutomationId + '-system-metadata-button'" type="button"
                [ngClass]="dataSet.representationType === RepresentationSet.SYSTEM_METADATA_INDEX ? 'btn-group-active' : 'btn-group-default'"
                (click)="setRepresentationType(RepresentationSet.SYSTEM_METADATA_INDEX)">
                <div>System Metadata</div>
                <i class="fa fa-caret-up up-caret-active"
                    [hidden]="dataSet.representationType !== RepresentationSet.SYSTEM_METADATA_INDEX"></i>
            </button>
            <button [disabled]="disableOption(RepresentationSet.METADATA_INDEX)"
                [attr.data-automation-id]="modalAutomationId + '-file-metadata-button'" type="button"
                [ngClass]="dataSet.representationType === RepresentationSet.METADATA_INDEX ? 'btn-group-active' : 'btn-group-default'"
                (click)="setRepresentationType(RepresentationSet.METADATA_INDEX)">
                <div>File Metadata</div>
                <i class="fa fa-caret-up up-caret-active"
                    [hidden]="dataSet.representationType !== RepresentationSet.METADATA_INDEX"></i>
            </button>
            <button [disabled]="disableOption(RepresentationSet.CONTENT_INDEX)"
                [attr.data-automation-id]="modalAutomationId + '-content-button'" type="button"
                [ngClass]="dataSet.representationType === RepresentationSet.CONTENT_INDEX ? 'btn-group-active' : 'btn-group-default'"
                (click)="setRepresentationType(RepresentationSet.CONTENT_INDEX)">
                <div>Content</div>
                <i class="fa fa-caret-up up-caret-active"
                    [hidden]="dataSet.representationType != RepresentationSet.CONTENT_INDEX"></i>
            </button>
            <button [disabled]="disableOption(RepresentationSet.VECTOR_SET)"
                [attr.data-automation-id]="modalAutomationId + '-analytic-button'" type="button"
                [ngClass]="dataSet.representationType === RepresentationSet.VECTOR_SET ? 'btn-group-active' : 'btn-group-default'"
                (click)="setRepresentationType(RepresentationSet.VECTOR_SET)">
                <div>Analytic</div>
                <i class="fa fa-caret-up up-caret-active"
                    [hidden]="dataSet.representationType != RepresentationSet.VECTOR_SET"></i>
            </button>
        </div>
    </div>
</res-base-modal>